var _defs, _line, _line2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFDeskRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eb464424-35d3-46da-8dbb-d00c66124403",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361.33 133.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e5ad973b-0b09-458b-a443-c1a73f885761,.fd1be5aa-15e5-4c38-9a76-df1ef21f037c{fill:none;stroke:#6F6F6F;stroke-width:0.5px;}.e5ad973b-0b09-458b-a443-c1a73f885761{stroke-miterlimit:10;}.e0fd6127-0930-4052-9a2c-943f8e8a62a4{fill:#6F6F6F;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e5ad973b-0b09-458b-a443-c1a73f885761",
    y1: 0.25,
    x2: 357.17,
    y2: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e5ad973b-0b09-458b-a443-c1a73f885761",
    x1: 357.17,
    y1: 124.48,
    x2: 357.17,
    y2: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ace5fa08-fd0d-4fc0-9e83-7bd9acf48819",
    "data-name": "Ellipse 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e0fd6127-0930-4052-9a2c-943f8e8a62a4",
    cx: 356.83,
    cy: 129.12,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fd1be5aa-15e5-4c38-9a76-df1ef21f037c",
    cx: 356.83,
    cy: 129.12,
    r: 4.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFDeskRight);
export default __webpack_public_path__ + "static/media/F-Desk-Right.fa56a892787f9cbdddf1712de22890f9.svg";
export { ForwardRef as ReactComponent };